/**
 * Configuration centralisée des informations de la company RAKB
 * Mettez à jour ce fichier pour changer les informations partout dans l'application
 */

export const companyInfo = {
  name: "RAKB",
  fullName: "RAKB - Location de Véhicules au Maroc",
  
  // Contact
  email: "contact@rakb.ma",
  phone: "+212 6 15 05 07 31",
  phoneFormatted: "+212 6 15 05 07 31",
  phoneDisplay: "+212 6 15 05 07 31",
  
  // Adresse
  address: {
    street: "Rabat",
    city: "Rabat",
    postalCode: "10000",
    country: "Maroc",
    full: "Rabat, 10000, Maroc"
  },
  
  // Horaires d'ouverture
  businessHours: {
    weekdays: "Du lundi au vendredi, de 9h à 18h",
    weekend: "Samedi de 9h à 13h",
    emergency: "Service d'urgence 24/7"
  },
  
  // Social Media
  social: {
    facebook: "https://facebook.com/rakb.ma",
    twitter: "https://twitter.com/rakb_ma",
    instagram: "https://instagram.com/rakb.ma",
    linkedin: "https://linkedin.com/company/rakb"
  },
  
  // Autres
  website: "https://rakb.ma",
  supportEmail: "support@rakb.ma",
  legalEmail: "legal@rakb.ma"
};

/**
 * Helper pour obtenir le lien tel: pour les numéros de téléphone
 */
export const getPhoneLink = (phone: string = companyInfo.phone) => {
  return `tel:${phone.replace(/\s/g, "")}`;
};

/**
 * Helper pour obtenir le lien mailto: pour les emails
 */
export const getEmailLink = (email: string = companyInfo.email) => {
  return `mailto:${email}`;
};

/** Message pré-rempli par défaut (bouton flottant, chatbot, contact générique). */
export const DEFAULT_WHATSAPP_MESSAGE =
  "Bonjour RAKB, je souhaite obtenir des informations sur la location de voiture.";

/**
 * Lien WhatsApp Business (ouvre la conversation avec le numéro RAKB).
 * Toujours avec un message pré-rempli : custom si fourni, sinon DEFAULT_WHATSAPP_MESSAGE.
 * Les templates véhicule (buildVehicleWhatsAppLink) passent leur propre message.
 * @param message - Message pré-rempli (optionnel)
 */
export const getWhatsAppLink = (message?: string) => {
  const phone = companyInfo.phone.replace(/\s/g, "").replace(/-/g, "").replace(/\+/g, "");
  const text = (message && message.trim()) || DEFAULT_WHATSAPP_MESSAGE;
  return `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
};
